export default __webpack_public_path__ + "static/media/primary.25f1fbaf.png";